import { createSelector } from "reselect";
import { SkipToken, skipToken } from "@reduxjs/toolkit/query";
import {
  BaseGetTradeExtraInfoDataRequest,
  GetTradeExtraInfoOrdersGraphRequest,
} from "@shared/types";
import { sharedLib } from "@shared/services/shared.service";
import { getPriceGraphDataWithActivities } from "@shared/features/trades/common/utils";

export const selectFormattedTradeExtraInfoOrdersGraphData = (
  args?: GetTradeExtraInfoOrdersGraphRequest | SkipToken,
  activitiesArgs?: BaseGetTradeExtraInfoDataRequest | SkipToken
) =>
  createSelector(
    sharedLib.sharedApi.trades.endpoints.getTradeExtraInfoOrdersGraph.select(
      args ?? skipToken
    ),
    sharedLib.sharedApi.trades.endpoints.getTradeExtraInfoActivities.select(
      activitiesArgs ?? skipToken
    ),
    ({ data }, { data: activitiesData }) => {
      const chartData =
        (args &&
          args !== skipToken &&
          data?.data?.graph_data?.[args.time_range]) ||
        [];
      if (chartData.length === 0) return [];
      const precisionConfig = data?.precision;
      return getPriceGraphDataWithActivities(
        chartData,
        activitiesData,
        precisionConfig
      );
    }
  );
